import { render } from "./SpendCard.vue?vue&type=template&id=115b102a"
import script from "./SpendCard.vue?vue&type=script&lang=js"
export * from "./SpendCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__